var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3644 14.2137L12.7466 13.4274L13.3644 14.2137ZM19 15C20.6569 15 22 13.6569 22 12H20C20 12.5523 19.5523 13 19 13V15ZM13.9822 15H19V13H13.9822V15ZM8.23564 19.5152L13.9822 15L12.7466 13.4274L7 17.9425L8.23564 19.5152ZM5 15V17.9425H7V15H5ZM3 15H5V13H3V15ZM0 12C0 13.6569 1.34315 15 3 15V13C2.44772 13 2 12.5523 2 12H0ZM0 3V12H2V3H0ZM3 0C1.34315 0 0 1.34315 0 3H2C2 2.44772 2.44772 2 3 2V0ZM19 0H3V2H19V0ZM22 3C22 1.34315 20.6569 0 19 0V2C19.5523 2 20 2.44771 20 3H22ZM22 12V3H20V12H22ZM7 15C7 13.8954 6.10457 13 5 13V15H7ZM7 17.9425H5C5 19.6114 6.92339 20.5462 8.23564 19.5152L7 17.9425ZM13.9822 13C13.5341 13 13.099 13.1505 12.7466 13.4274L13.9822 15V13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMessage);
export default __webpack_public_path__ + "static/media/ico-message.1535245bcdc26d993b15c03e975c2d74.svg";
export { ForwardRef as ReactComponent };